<template>
  <TheUncle :color="true" :title="title" :description="description">
    <a-select v-model="sort.name" defaultValue="asc" @change="onSorting" style="min-width: 80px">
      <a-select-option value="asc">가나다 순</a-select-option>
      <a-select-option value="desc">가나다 역순</a-select-option>
    </a-select>
    <a-select v-model="sort.time" defaultValue="desc" @change="onSorting" style="min-width: 80px">
      <a-select-option value="desc">최근 순</a-select-option>
      <a-select-option value="asc">오래된 순</a-select-option>
    </a-select>
    <a-select v-model="sort.rows" :defaultValue="null" @change="onSorting" style="min-width: 90px">
      <a-select-option :value="null">전체 열</a-select-option>
      <a-select-option value="ab">A/B 열</a-select-option>
      <a-select-option value="cd">C/D 열</a-select-option>
      <a-select-option value="ef">E/F 열</a-select-option>
      <a-select-option value="gh">G/H 열</a-select-option>
      <a-select-option value="ij">I/J 열</a-select-option>
      <a-select-option value="kl">K/L 열</a-select-option>
    </a-select>
    <a-select
      v-model="sort.location"
      defaultValue="asc"
      @change="onSorting"
      style="min-width: 80px"
    >
      <a-select-option value="asc">위치 순</a-select-option>
      <a-select-option value="desc">위치 역순</a-select-option>
    </a-select>
    <a-select v-model="sort.floor" :defaultValue="null" @change="onSorting" style="min-width: 80px">
      <a-select-option :value="null">전층</a-select-option>
      <a-select-option :value="floor" v-for="floor in floors" :key="floor">{{ floor }}층</a-select-option>
    </a-select>
    <a-collapse accordion style="margin-top: 0.5em;" @change="onChange">
      <a-collapse-panel
        v-for="saib in displaySaibs"
        :key="saib.idx"
        :class="saib.status === 4 ? 'admin-color-4' : ''"
        :header="`
          [${ saib.type === 0 ? '사입': '교환 / 반납' }][${saib.status === 0 ? '접수' 
          : saib.status === 1 ? '처리 중' 
          : saib.status === 2 ? '성공' 
          : saib.status === 3 ? '실패' : saib.type === 0 ? '대기' : '맡김' }] ${saib.account.username}:
          ${saib.wholesale.location.floor}층 ${
            saib.wholesale.location.row
          }열 ${saib.wholesale.location.place}호 - ${saib.wholesale.name} (${saib.account.username})`
        "
      >
        <p style="margin-left: 10px; margin-top: 0.5em;">
          <b>- 기본 정보:</b>
        </p>
        <p style="margin-left: 20px">
          <b>- 거래 타입:</b>&nbsp;
          <b>
            <span v-if="saib.type === 0" class="cl-green">사입</span>
            <span v-else-if="saib.type === 1" class="cl-red">교환 / 반납</span>
            <span v-else class="cl-yellow">알 수 없음</span>
          </b>
        </p>
        <p style="margin-left: 20px;">
          <b>- 사용자 이름:</b>
          {{ saib.account.username }}
        </p>
        <p style="margin-left: 20px;">
          <b>- 사용자 잔액:</b>
          {{ saib.account.balance.current.toLocaleString() }}원
        </p>
        <p style="margin-left: 20px;">
          <b>- 등록 시간:</b>
          {{ $moment(saib.uploadAt).format('llll') }}
        </p>
        <br />
        <p style="margin-left: 10px;">
          <b>- 도매 정보:</b>
        </p>
        <p style="margin-left: 20px;">
          <b>- 이름:</b>
          {{ saib.wholesale.name }}
        </p>
        <p style="margin-left: 20px;">
          <b>- 전화번호:</b>
          <a
            class="ant-btn"
            :href="`tel://${saib.wholesale.phone}`"
            style="color: #000;"
          >{{ saib.wholesale.phone }}</a>
        </p>
        <p style="margin-left: 20px;">
          <b>- 휴대폰:</b>
          <a
            class="ant-btn"
            :href="`tel://${saib.wholesale.mobile}`"
            style="color: #000;"
          >{{ saib.wholesale.mobile }}</a>
        </p>
        <br />
        <a-radio-group buttonStyle="solid" style="margin-bottom: 0.3em;" v-model="status">
          <a-radio-button :value="1">
            <a-icon type="sync" />&nbsp;처리
          </a-radio-button>
          <a-radio-button :value="3">
            <a-icon type="close" />&nbsp;실패
          </a-radio-button>
          <a-radio-button :value="4" v-if="saib.type === 0">
            <a-icon type="warning" />&nbsp;대기
          </a-radio-button>
          <a-radio-button :value="4" v-else>
            <a-icon type="warning" />&nbsp;맡김
          </a-radio-button>
          <a-radio-button :value="2">
            <a-icon type="check" />&nbsp;성공
          </a-radio-button>
        </a-radio-group>
        <a-table :columns="columns" :dataSource="saib.details" size="small" :pagination="false">
          <p
            :slot="status !== 1 ? 'expandedRowRender' : ''"
            style="margin: 0"
            slot-scope="record, index"
          >
            <a-input
              v-model="details[index].reason"
              placeholder="메세지를 입력해주세요."
              :style="`margin-top: 0.5em; ${status === 2 ? 'width: 55%' : ''}`"
            />
            <a-input-number
              v-if="status === 2"
              v-model="details[index].price"
              placeholder="금액"
              @change="onChangePrice"
              :formatter="
                value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="value => value.replace(/\$\s?|(,*)/g, '')"
              :style="
                `margin-top: 0.75em; margin-left: 0.3em; ${
                  status === 2 ? 'margin-right: 0.3em; width: 35%;' : ''
                }`
              "
            />
          </p>
        </a-table>
        <a-input
          v-if="status !== 1"
          v-model="reason"
          placeholder="메세지를 입력해주세요."
          :style="`margin-top: 0.5em; ${status === 2 ? 'width: 60%' : ''}`"
        />
        <a-input-number
          v-if="status === 2"
          style="margin-top: 0.3em; margin-left: 0.3em; width: 35%;"
          @change="onFirstPrice"
          :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :parser="value => value.replace(/\$\s?|(,*)/g, '')"
          placeholder="금액"
          v-model="price"
        />
        <p v-if="saib.type !== 0" style="margin-top: 0.5em;">
          <b>사유:</b>
          {{ saib.reason || '별도의 사유를 작성하지 않으셨습니다.' }}
        </p>
        <p v-if="saib.sended" style="margin-top: 0.5em; margin-left: 0.2em;">
          <b>도매 메세지:</b>
          {{ saib.answer || '메세지가 아직 오지 않았습니다.' }}
        </p>
        <p v-if="saib.readAt" style="margin-top: 0.5em; margin-left: 0.2em;">
          {{ new Date(saib.readAt).getHours() }}시 {{ new Date(saib.readAt).getMinutes() }}분
          <b>읽음</b>
        </p>
        <a-button-group style="margin-top: 0.3em;">
          <a-button
            @click="sendMessage(saib.idx)"
            v-if="saib.type === 0"
            :disabled="
              !saib.wholesale.allowMessage ||
                saib.sended ||
                sended.includes(saib.idx)
            "
            :loading="loading"
            icon="phone"
          >
            {{
            saib.sended || sended.includes(saib.idx)
            ? '전송됨'
            : saib.wholesale.allowMessage
            ? '전송'
            : '수신 거부됨'
            }}
          </a-button>
          <a-button :loading="loading" @click="onSave" type="primary" icon="save">저장</a-button>
        </a-button-group>
      </a-collapse-panel>
    </a-collapse>
  </TheUncle>
</template>
<script>
import TheUncle from "@/components/Uncle/TheUncle";
import Axios from "axios";
import config from "../../../config";
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import OPCODE from "../../../libs/OPCODE";
import { mapMutations } from "vuex";
import { TYPES } from "../../../stores/uncle";
import _ from "lodash";

export default {
  name: "UnclePending",
  components: { TheUncle },
  methods: {
    ...mapMutations([TYPES.UNCLE_SEND_MESSAGE]),
    openMessage() {
      this[TYPES.UNCLE_SEND_MESSAGE](true);
    },
    async onLoad() {
      try {
        this.loading = true;
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/uncle/saib/pending/secondary/${this.$route.params.idx}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.title = data.title;
              this.description = data.description;
              this.saibs = data.saibs;
              this.displaySaibs = data.saibs;
              this.onSorting();

              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류가 발생했습니다."
              });
              break;
          }
        }
      } catch (err) {
        this.$router.push("/uncle/pending");
        config.alert.mixin({
          type: "error",
          title: "오류가 발생했습니다. 인터넷 상태를 확인해주세요."
        });
      }
      this.loading = false;
    },
    onChange(idx) {
      let saib = null;
      for (const s of this.saibs) {
        if (s.idx === idx) {
          saib = s;
          break;
        }
      }

      if (!saib) return;
      this.idx = saib.idx;
      this.price = saib.price;
      this.status = saib.status;
      this.reason = saib.contents;
      this.details = saib.details;
    },
    onFirstPrice() {
      let isFirst = true;
      if (!this.price) this.price = 0;
      for (const i in this.details) {
        if (isFirst) {
          this.details[i].price = this.price;
          isFirst = false;
        } else {
          this.details[i].price = 0;
        }
      }
      this.onChangePrice();
    },
    onChangePrice() {
      this.price = 0;
      for (const detail of this.details) {
        this.price += parseInt(detail.price || 0);
      }
    },
    async onSave() {
      try {
        this.loading = true;
        const { reason, details, price } = this;
        const { data } = await Axios.post(
          `${config.hostname}/v1/uncle/saib/pending/${this.idx}?status=${this.status}`,
          { reason, details, price },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              if (this.status === 2) {
                this.price = 0;
              }

              config.alert.mixin({
                type: "success",
                title: `저장되었습니다.`
              });
              await this.onLoad();
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: `알 수 없는 오류가 발생했습니다.`
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "인터넷에 연결할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.loading = false;
    },
    async sendMessage() {
      try {
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/uncle/saib/pending/${this.idx}/send`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.sended.push(this.idx);
              config.alert.mixin({
                type: "success",
                title: "문자 메세지를 전송했습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "문자 메세지를 전송하지 못했습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "인터넷에 연결할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
    },
    onSorting() {
      const { floor, rows, name, time } = this.sort;
      this.displaySaibs = JSON.parse(JSON.stringify(this.saibs));

      if (floor) {
        _.remove(
          this.displaySaibs,
          saib => saib.wholesale.location.floor !== floor
        );
      }

      if (rows) {
        _.remove(
          this.displaySaibs,
          saib => !rows.includes(saib.wholesale.location.row.toLowerCase())
        );
      }

      this.displaySaibs = _.orderBy(
        this.displaySaibs,
        [
          i => i.wholesale.name,
          i => i.uploadAt,
          ({ wholesale }) => wholesale.floor + wholesale.row + wholesale.place
        ],
        [name, time]
      );
    }
  },
  data() {
    this.onLoad();
    return {
      title: "로딩 중...",
      description: "가져오는 중입니다.",
      displaySaibs: [],
      saibs: [],
      sended: [],
      loading: false,
      sort: {
        name: "asc",
        time: "desc",
        location: "asc",
        floor: null,
        rows: null
      },

      /* Editing Start */
      idx: null,
      status: null,
      reason: "",
      price: 0,
      details: [],
      /* Editing End */

      columns: [
        {
          title: "품명",
          dataIndex: "name"
        },
        {
          title: "수량",
          dataIndex: "amount"
        }
      ]
    };
  }
};
</script>
<style scoped>
.ant-card-body {
  padding: 0px;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 2px;
}
</style>
